"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '136px'
    },
    img: {
      maxWidth: '100%',
      maxHeight: '100%'
    },
    description: {
      padding: theme.spacing(1, 0),
      paddingBottom: theme.spacing(2)
    },
    imageWrapper: function imageWrapper(props) {
      return {
        width: '136px',
        height: '136px',
        marginBottom: theme.spacing(2),
        borderRadius: '5px',
        cursor: 'pointer',
        background: "url(".concat(props.image, ") no-repeat center center"),
        backgroundSize: 'contain'
      };
    }
  };
});

var ProductListItemComponent = function ProductListItemComponent(_ref) {
  var id = _ref.id,
      image = _ref.image,
      name = _ref.name,
      price = _ref.price,
      vendor = _ref.vendor,
      hasExternalFulfillment = _ref.hasExternalFulfillment,
      isLoading = _ref.isLoading,
      onClick = _ref.onClick,
      onImageClick = _ref.onImageClick;
  var classes = useStyles({
    image
  });
  var onChoose = (0, _react.useCallback)(function () {
    return onClick(id);
  }, [id, onClick]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    container: true,
    direction: "column",
    justifyContent: "space-between",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    "data-testid": "CreateGift-ProposedProductItem-Image",
    container: true,
    justifyContent: "center",
    alignItems: "center",
    className: classes.imageWrapper,
    onClick: onImageClick
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Success-Bold"
  }, price), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    className: classes.description
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static-Bold"
  }, name), !hasExternalFulfillment && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Inactive"
  }, "from ", vendor))), /*#__PURE__*/_react.default.createElement(_material.Button, {
    "data-testid": "CreateGift-ProposedProductItem-Choose",
    variant: "contained",
    color: "secondary",
    onClick: onChoose,
    disabled: isLoading
  }, "Choose"));
};

ProductListItemComponent.propTypes = {
  id: _propTypes.default.number.isRequired,
  image: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  price: _propTypes.default.node.isRequired,
  vendor: _propTypes.default.string.isRequired,
  hasExternalFulfillment: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired,
  onImageClick: _propTypes.default.func.isRequired,
  isLoading: _propTypes.default.bool.isRequired
};
var _default = ProductListItemComponent;
exports.default = _default;